<template>
  <div class="index-container"
       data-title="登录">
    <mt-spinner v-show="initialloading"
                type="snake"
                color="#00ccff"
                :size="20"></mt-spinner>
    <div class="top">
      <div class="icon-area">
        <div class="img-style">
          <img :src="headimgurl" />
        </div>
        <span>{{user.curMemberGrade}}</span>
        <!-- {{nextValue>0?user.curMemberGrade:user.nextMemberGrade}} -->
      </div>
      <div class="top-content">
        <div class="uname">
          <div class="name"
               @click="goToInfo">{{nickname}}</div>
          <div class="mobile">{{user.mobile}}</div>
        </div>
        <div @click="goToGrowthValue">
          <span class="growth-style">{{nextValue>0?('还差'+nextValue+'成长值即可升至'+user.nextMemberGrade):'当前已为最高等级'}}</span>
          <mt-progress :value="growth"></mt-progress>
        </div>
        <!-- <mt-progress :value="progressWidth" :bar-height="user.growth"></mt-progress> -->
      </div>
    </div>
    <div class="nav">
      <router-link class="nav-items"
                   :to="{path:'/Member/RemaindSum',query: {amount: user.cashAmount}}">
        <span>{{user.cashAmount}}</span>我的余额
      </router-link>
      <router-link class="nav-items"
                   :to="{path:'/Member/Integral',query: {score: user.score}}">
        <span>{{user.score}}</span>我的积分
      </router-link>
    </div>
    <div class="advertise-img">
      <template v-if="imglist&&imglist.length>1">
        <div class="banner1 bannerItem">
          <mt-swipe :auto="4000">
            <mt-swipe-item v-for="(item,index) in imglist"
                           :key="index">
              <img :src="item.url"
                   alt
                   @click="toLink(item.linkUrl)" />
            </mt-swipe-item>
          </mt-swipe>
        </div>
      </template>
      <template v-else-if="imglist&&imglist.length==1">
        <img :src="imglist[0].url"
             @click="toLink(imglist[0].linkUrl)" />
      </template>
      <template v-else>
        <img src="../../assets/img/ucenter_08.jpg" />
      </template>
    </div>
    <div class="menu-list">
      <div class="line-items">
        <router-link class="content"
                     :to="{path:'/Member/Pay',query:{cashAmount:user.cashAmount}}">
          <img src="../../assets/img/ucenter_10.png" />付款码
        </router-link>
        <router-link class="content"
                     to="/Member/Order">
          <img src="../../assets/img/ucenter_02.png" />我的订单
        </router-link>
        <router-link class="content"
                     to="/Member/Recharge">
          <img src="../../assets/img/ucenter_07.png" />充值
        </router-link>
      </div>
      <div class="line-items">
        <router-link class="content"
                     :to="{path:'/Member/SaleDetail',query: {amount: user.cashAmount}}">
          <img src="../../assets/img/ucenter_17.png" />交易明细
        </router-link>
        <router-link class="content"
                     to="/Member/Coupon">
          <img src="../../assets/img/ucenter_12.png" />优惠券
        </router-link>
        <router-link class="content"
                     to="/Member/SignIn">
          <img src="../../assets/img/ucenter_19.png" />签到有礼
        </router-link>
      </div>
      <div class="line-items">
        <!-- <router-link class="content" to="/Member/Advice">
          <img src="../../assets/img/ucenter_23.png">服务建议
        </router-link>-->
        <router-link class="content"
                     to="/Member/Info">
          <img src="../../assets/img/ucenter_03.png" />编辑资料
        </router-link>
        <router-link class="content"
                     :to="{path:'/Member/Set',query: {mobile: user.curMobile+''}}">
          <img src="../../assets/img/ucenter_27.png" />设置
        </router-link>
        <a class="content">&nbsp;</a>
      </div>
      <!-- <div class="line-items">
        <router-link class="content" to="/Member/Clear">清空缓存</router-link>
      </div>-->
    </div>
    <gfooter></gfooter>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { mapActions } from "vuex";
import avatar from "@/assets/img/avatar.jpg";
import common from "@/libs/common";
import { localToken } from "@/libs/func";
import { Swipe, SwipeItem } from "mint-ui";
import advertApi from "@/api/api-advert";
import globConfig from "@/config/config";
export default {
  name: "Index",
  data () {
    return {
      user: {
        mobile: null, // 部分隐藏手机号
        curMobile: null, // 手机号
        curMemberGrade: "未知", // 当前等级
        nextMemberGrade: "未知", // 目标等级
        nextGradeGrowValue: 0, // 下一个等级成长值
        ratetoNext: 0,
        score: 0,
        growth: 0,
        cashAmount: 0
      },
      progressWidth: 60, // 进度条宽度
      initialloading: true,
      headimgurl: null,
      nickname: "未知",
      growth: 0,
      nextValue: 0, // 距下一个等级还差多少
      imglist: [] //首页广告图片
    };
  },
  methods: {
    ...mapActions(["getUserInfo", "checkDn"]),
    goToInfo () {
      this.$router.push({
        path: "/Member/Info"
      });
    },
    goToGrowthValue () {
      common.toJump(this, "/Member/GrowthValue", {
        GrowthValueNum: this.user.growth,
        // NeedGrowthValueNum: this.user.nextGradeGrowValue,
        NeedGrowthValueNum: this.nextValue,
        curMemberGrade: this.user.curMemberGrade,
        nextMemberGrade: this.user.nextMemberGrade
      });
    },
    getBaseInfo () {
      let that = this;
      that.getUserInfo().then(
        res => {
          res.cashAmount = common.toDecimal2(res.cashAmount);
          that.headimgurl = res.img ? res.img : avatar;
          that.nickname = res.name ? res.name : "未知";
          that.user = res;
          that.user.curMobile = res.mobile;
          that.user.mobile =
            res.mobile.substr(0, 3) + "****" + res.mobile.substr(7);
          // Max 为最高等级
          if (
            res.nextMemberGrade == "Max" ||
            res.growth > parseInt(res.nextGradeGrowValue)
          ) {
            that.growth = 100;
            that.nextValue = 0;
          } else {
            // that.growth =
            //   Math.round(
            //     (res.growth /
            //       (parseInt(res.growth) + parseInt(res.nextGradeGrowValue))) *
            //       10000
            //   ) / 100.0;
            that.growth =
              Math.round(
                (res.growth / parseInt(res.nextGradeGrowValue)) * 10000
              ) / 100.0;
            that.nextValue = res.nextGradeGrowValue - res.growth;
          }
        },
        err => {
          that.headimgurl = avatar;
        }
      );
      that.initialloading = false;
    },
    // 获取首页广告图片
    getAdvertList () {
      let that = this;
      advertApi.getAdvertList({ AdvertTagType: 2 }).then(
        res => {
          that.imglist = res;
        },
        err => {
          console.log(err, "获取首页广告图片失败！");
        }
      );
    },
    toLink (linkUrl) {
      let that = this;
      let isInside = false;

      if (linkUrl) {
        console.log(linkUrl);
        // linkUrl.includes(globConfig.linkUrl) // 判断是否为内部链接
        // linkUrl.startsWith("http") // 判断是否完整链接
        // 不是内部链接情况下做特殊处理=》加参数=》判断=》顺利到达指定页面
        if (linkUrl.startsWith("http")) {
          isInside = true;
          window.location.href = linkUrl;
          return;
        }
        if (!linkUrl.includes(globConfig.linkUrl)) {
          isInside = true;
        }
        that.$router.push({
          path: linkUrl,
          query: { isInside: isInside }
        });
      }
    }
  },
  mounted () {
    this.getBaseInfo();
    this.getAdvertList();
    let dn = this.$route.query.dn || null;
    if (dn) {
      this.checkDn(dn);
    }
    // 获取首页广告
  }
};
</script>
<style lang="less">
// body,
// #app {
//   height: 100%;
// }
.index-container {
  height: inherit;
  background: #fff;
  .top {
    display: flex;
    align-items: center;
    height: 130px;
    width: 100%;
    .icon-area {
      margin: 0 10px;
      height: 75px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      img {
        width: 70px;
        height: 70px;
        border-radius: 50%;
      }
      .img-style {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        border: 2px solid #2181d4;
      }
      span {
        font-size: 12px;
        color: #fff;
        background-color: #2181d4;
        padding: 2px 4px;
        border-radius: 5px;
        position: absolute;
        bottom: 0px;
        text-align: center;
      }
    }
    .top-content {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      // margin-bottom: 10px;
      height: 70px;
      width: 65%;
      .uname {
        margin-bottom: 6px;
        color: #666;
        font-size: 12px;
        display: flex;
        align-items: center;
        .name {
          margin-right: 10px;
          color: #1a1a1a;
          font-size: 14px;
          font-weight: bold;
          max-width: 100px;
          overflow: hidden;
          word-break: keep-all;
        }
        .mobile {
          flex: 1;
        }
      }

      span {
        font-size: 12px;
        color: #666;
        // margin-bottom: 10px;
      }
      .growth-style {
        overflow: hidden;
        word-break: keep-all;
      }
      .mt-progress {
        margin-top: 6px;
        height: 6px;
        border: 1px solid #acacac;
        border-radius: 5px;
        .mt-progress-content {
          .mt-progress-runway {
            background-color: #fff;
          }
          .mt-progress-progress {
            background-color: #2181d4;
            border-radius: 5px;
          }
        }
      }
    }
    /* .icon-style{
      flex:1;
      text-align:right;
      margin-right:20px;
      img{
        width:25px;
        height:25px;
      }
    } */
  }
  .nav {
    width: 100%;
    height: 65px;
    border-top: 1px solid #e4e4e4;
    // border-bottom: 5px solid #e4e4e4;
    display: flex;
    align-items: center;
    .nav-items {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // height:40px;
      width: 50%;
      font-size: 14px;
      color: #666;
      span {
        color: #2181d4;
        margin-bottom: 5px;
        font-weight: bold;
        // font-size: 14px;
      }
    }
    .nav-items:first-child {
      border-right: 1px solid #e4e4e4;
    }
  }
  .advertise-img {
    // padding:15px 10px 0 10px;
    img {
      width: 100%;
    }
  }
  .menu-list {
    margin-bottom: 40px;
    .line-items {
      border-bottom: 1px solid #e4e4e4;
      display: flex;
      align-items: center;
      height: 80px;
      .content:nth-child(3n) {
        border-right: none;
      }
      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        color: #999;
        font-size: 14px;
        border-right: 1px solid #e4e4e4;
        img {
          margin-bottom: 5px;
          width: 27px;
          height: 22px;
        }
      }
    }
  }
  .foot {
    position: absolute;
    bottom: 5px;
    text-align: center;
  }
  #footer.indexFooter {
    text-align: center;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: none;
    img {
      width: 45%;
    }
  }
}

.bannerItem {
  width: 100%;
  position: relative;
  padding-bottom: 28.5%;
  height: 0;
}
.bannerItem:last-child {
  // margin-bottom: 40px;
}
.bannerItemTitle {
  padding: 10px 0;
  text-align: center;
}
.bannerItem > div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  // height: 100% !important;
}
.mint-swipe-item img {
  width: 100%;
  // height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/Member/Index.vue